<template>
    <section>
        <div class="lesson_item" v-for="(itemLesson, indexLesson) in lessonArray" :key="indexLesson">
            <div class="lesson_item_main" @click="lessonItemClick(getCount(isFreeTrial), itemLesson.pk)">
                <div class="lesson_item_left">
                    <img :src="$qiNiuDomainBase + itemLesson.cover + '?imageView2/1/w/200/h/200'"/>
                </div>
                <div class="lesson_item_center">
                    <div class="lesson_content">
                        <div class="name">{{itemLesson.title}}</div>
                        <div class="description" v-html="itemLesson.keywords"></div>
                    </div>
                </div>
                <div class="clear"></div>
                <div v-if="getCount(isFreeTrial) === 1" class="free_trial">可试用</div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            lessonArray: {
                type: Array,
                default:() => []
            },
            isFreeTrial:{
                type: String,
                default: '0'
            }
        },
        methods: {
            lessonItemClick(isFreeTrial, lesson) {
                this.$emit('lessonItemClick', isFreeTrial, lesson);
            }
        }
    }
</script>

<style scoped>
    img { pointer-events: none; }

    .lesson_item .lesson_item_main {
        position: relative;
        background-color: white;
        margin-left: 10px;
        margin-right: 10px;
        margin-top: 20px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid rgba(255, 255, 255, 100);
        padding: 0;
        font-size: 0;
    }
    .lesson_item .lesson_item_main .lesson_item_left {
        float: left;
        width: 100px;
        margin: 15px 10px;
    }
    .lesson_item .lesson_item_main .lesson_item_left img {
        width: 100%;
        height: 100%;
        border: 1px solid #bbbbbb;
    }
    .lesson_item .lesson_item_main .lesson_item_center {
        float: left;
        margin-left: 5px;
        width: calc(100% - 105px - 30px);
        height: 130px;
        display: flex;
        align-items: center;
    }
    .lesson_item .lesson_item_main .lesson_content {
        width: 100%;
    }
    .lesson_item .lesson_item_main .lesson_item_center .name {
        font-size: 18px;
        font-weight: bold;
        margin-top: 10px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .lesson_item .lesson_item_main .lesson_item_center .description {
        font-size: 15px;
        color: #666666;
        margin-top: 3px;
        margin-bottom: 10px;
        margin-right:15px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .lesson_item .lesson_item_main .img_down {
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        right: 12px;
    }
    .free_trial {
        position: absolute;
        top: 0;
        right:0;
        background-color: #ff5a50;
        font-size: 13px;
        font-weight: bold;
        color: white;
        padding: 2px 5px 2px 5px;
        border-top-right-radius:5px;
        -webkit-border-top-right-radius: 5px;
        -moz-border-radius-topright: 5px;
    }
</style>
